import type { Optional, Primitive } from 'utility-types';

import { type ButtonClick, buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

export const buttonPressed = (
  context: TrackingContextValue,
  { value, ...data }: Optional<ButtonClick, 'buttonName'> & { value?: number },
  trackingDimensions?: Record<string, string[] | Primitive> | undefined
) => {
  if (!data.buttonName) return;
  GAEvent({ action: 'Button Pressed', label: data.buttonName, value }, context, trackingDimensions);
  buttonClick(data as ButtonClick, context);
};
